import { render, staticRenderFns } from "./StoreUserPermissions.vue?vue&type=template&id=2cc8a8f2"
import script from "./StoreUserPermissions.vue?vue&type=script&lang=js"
export * from "./StoreUserPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports